import core, { GQL, View, API } from '@gin-betting/core';

import {
    GET_TOP_TOURNAMENTS_REQUEST,
    SET_TOP_TOURNAMENTS_SUCCESS,
    GET_MISSING_MATCHES_REQUEST,
} from './constants';
import { GetTopTournamentsRequestAction } from './types';

const {
    utils: { makeAction },
    entities: {
        actions: { makeGetMissingMatches },
    },
} = core;

export function getTopTournaments(
    variables: GQL.GetTopTournamentsQueryVariables
): GetTopTournamentsRequestAction {
    return {
        type: GET_TOP_TOURNAMENTS_REQUEST,
        payload: {
            method: 'getTopTournaments',
            variables,
        },
        meta: { isApiCall: true },
    };
}

export const setNormalizeTournaments = (
    payload: View.Normalized | { tournaments: Array<Partial<API.Tournament>> }
) => makeAction(SET_TOP_TOURNAMENTS_SUCCESS, payload);

export const getMissingMatches = makeGetMissingMatches({
    type: GET_MISSING_MATCHES_REQUEST,
    withMarketsCount: true,
});

export const Actions = {
    getTopTournaments,
    setNormalizeTournaments,
};
